import React, { useState } from 'react'
import { BrComponent } from '@bloomreach/react-sdk'
import Selector from './Selector.jsx'
import { selectorContainers, defaultContainers } from './selectorContainers.js'

const SelectorLayout = () => {
  const [role, setRole] = useState('')
  const containers = selectorContainers[role] || defaultContainers

  return (
    <>
      {containers.map(({ id, hidden }) => (
        <div
          key={id}
          id={`Selector-container${id}`}
          className={`${hidden ? ' u-hidden' : ''}`}
        >
          <BrComponent path={`container${id}`} />
          {id === 0 && <Selector value={role} onChange={setRole} />}
        </div>
      ))}
    </>
  )
}

export default SelectorLayout
